import Text from "../../shared/components/Text";
import Spacer from "../../shared/components/Spacer";
import Card from "../../shared/components/Card";
import Padding from "../../shared/components/Padding";
import Input from "../../shared/components/Input";
import "react-datepicker/dist/react-datepicker.css";
import Flex from "../../shared/components/Flex";
import useDevice from "../../shared/hooks/useDevice";
import Label from "../../shared/components/Label";
import { useState } from "react";
import moment from "moment";
import GridInfo from "../../shared/components/GridInfo";
import AgGridTable from "../common/AgGridTable";
//#endregion 추가된소스

function MainComponent({search, grid}) {
    const [searchVal,setSearchVal] = useState({});
    const device = useDevice();
    const isMobile = device !== "desktop";

    const commonSearch = (searchSetter) => {
        searchSetter({req:searchVal});
    }

    return (
        <div className="contents" style={{padding:"0px"}}>
            <Card fullWidth>
                <Padding>
                    <Flex flexDirection={isMobile ? "column" : "row"} gap={30}>
                        <Flex alignItems="center" >
                            <Text size={"sm"} weight={"medium"} style={{width: "70px"}}>주소</Text>
                            <Input id="address" placeholder="주소를 입력해 주세요" style={{flex: 1}} maxLength={20}
                                {...(isMobile ? { fullWidth: true } : {})}
                                onChange={({target}) => {
                                                            setSearchVal({...searchVal,["address"]:target.value})
                                                        }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        commonSearch(search.searchSetter);
                                    }
                                }} />
                        </Flex>
                        <Flex alignItems="center" >
                            <Text size={"sm"} weight={"medium"} style={{width: "70px"}}>담당부서</Text>
                            <Input id="department" placeholder="담당부서를 입력해 주세요" style={{flex: 1}} maxLength={20} 
                                {...(isMobile ? { fullWidth: true } : {})}
                                onChange={({target}) => {
                                                            setSearchVal({...searchVal,["department"]:target.value})
                                                        }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        commonSearch(search.searchSetter);
                                    }
                                }} />
                        </Flex>
                        <Flex noWrap={false} flexDirection={isMobile ? "column" : "row"} gap={12} fullWidth={isMobile} style={{userSelect: "none"}}>
                            <Label title="설치일" style={{width: "8ch", cursor: "text", userSelect: "none"}}>설치일</Label>
                            <Flex fullWidth={isMobile} gap={10} flexDirection={isMobile ? "column" : "row"} alignItems="center">
                                <Input
                                    fullWidth={isMobile}
                                    width={180}
                                    type="date"
                                    onChange={({target}) => {
                                        const date = moment(target.value);
                                        const mDate = moment(date).format('YYYY.MM.DD HH:mm:ss');
                                        setSearchVal({...searchVal,["startDate"]:mDate})
                                    }}
                                    onBlur={async ({target}) => {
                                        commonSearch(search.searchSetter);
                                    }}
                                />
                                {!isMobile && <Text size={20}>~</Text>}
                                <Input
                                    width={180}
                                    fullWidth={isMobile ? true : false}
                                    type="date"
                                    onChange={({target}) => {
                                        const date = moment(target.value);
                                        const mDate = moment(date).format('YYYY.MM.DD HH:mm:ss');
                                        setSearchVal({...searchVal,["endDate"]:mDate})
                                    }}
                                    onBlur={async ({target}) => {
                                        commonSearch(search.searchSetter);
                                    }}
                                />
                            </Flex>
                        </Flex>
                    </Flex>
                </Padding>
            </Card>

            <Spacer direction="vertical" size={20} />

            <div className="page_contents" style={{minHeight:"380px"}}>
            <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <GridInfo title="제품목록" width={620}
                            content="항목을 더블클릭하면 선택한 제품의 수정 또는 상세 정보 화면으로 이동할 수 있는 선택 창이 표시됩니다." />
                <Spacer direction='vertical' size={15} />
                    <AgGridTable
                        {...grid}
                        onRowClicked={(evt) => {
                            grid.setSelectedRowImei(evt.data.imei);
                        }}
                        getRowStyle={(params) => {
                                if (params.data.imei === grid.selectedRowImei) {
                                    return { backgroundColor: 'rgb(255, 245, 220)' }
                                }
                                return undefined;
                            }}
                        tooltipShowDelay={0}
                        tooltipHideDelay={2000}
                    />
                </Padding>
            </Card>
            </div>
        </div>
    )
}

export default MainComponent;